import React, {useContext} from 'react'
import Layout from '../components/Layout/Layout'
import { useAuth } from '../context/auth'
const HomePage = () => {
  const [auth,setAuth] = useAuth();
   console.log(setAuth,'hii');

   

  return (
    <Layout title={"Home - WPX ERP"}>
        <div className='container'>
          <h1 className='page-title'>Welcome to WPX ERP</h1>
        </div>
    </Layout>
  )
}

export default HomePage